<template>
  <div id="self_media_header">
    <div class="preface">
      <!-- <div class="img1">
        <div class="left"><img :src="require('@/assets/images/selfMedia/logo_red.png')" /></div>
        <span class='interval'></span>
        <span class="app">客户端</span>
      </div>
      <div class="img2"><img :src="require('@/assets/images/selfMedia/invite.png')" /></div>
      <p class="explain">
      《农民日报》创刊于1980年4月6日，由邓小平同志亲笔题写报名。是我国历史上第一张面向全国农村发行的报纸，是全国性、综合性的中央级党报；是党和政府指导全国农业和农村工作重要典论工具。<br>
      农民日报客户端是农民日报社在移动互联网上搭建的三农类“资讯+政务+服务”平台。“三农号”是农民日报客户端的媒休/自媒体平台。面向全国党政机关、媒体、机构、专家和自媒体开放入驻，是基于线上交互、发布原创内容的独立用户号，由农民日报社统一管理。目前，全国30个省区市农办已入驻农民日报客户端，多家主流媒体、党政机关优质自媒休也已入驻。<br>
      我们将持续邀请全国党政机关、媒体、机构、专家和自媒休等有影响力的创作者入驻农民日报客户端，展现新时代三农的新面貌，反映三农的愿望与呼声，共同繁荣三农内容创作，唱响三农传播主旋律。
      </p> -->
      <!-- <div class="logo"><img :src="require('@/assets/images/selfMedia/logo_red.png')" /></div> -->

      <img :src="require('@/assets/images/selfMedia/bg02.png')" />
    </div>
    
  </div>
</template>

<script>
export default {
    
}
</script>

<style lang='scss' scoped>
#self_media_header{
  width: 100%;
  .preface{
   
    font-size: 23px;
    font-weight: 600;
    line-height: 40px;
    // font-family: cursive;
    overflow: auto;
    img{
      width: 100%;
    }
  }
  .img1{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 35px;
    .left{
      width: 155px;
      img{
        width: 100%;
      }
    }
    .interval{
      width: 2px;
      height: 30px;
      background: #d81418;
      margin: 0 10px;
    }
    .app{
      color: #d81418;
      font-size: 38px;
    }
  }
  .img2{
    text-align: center;
    margin-bottom: 25px;
    img{
      width: 225px;
    }
  }
  .explain{
    border-radius: 5px;
    padding: 10px;
    box-shadow: 0px 0px 8px #fff;
    background: rgba(255,255,255,0.4);
  }
  .logo{
    width: 80px;
    height: 80px;
    margin: 50px auto;
    background: #fff;
    text-align: center;
    line-height: 80px;
    border-radius: 10px;
    img{
      width: 65px;
    }
  }

  
}

</style>